import { useTrainingBalance } from '@/hooks/useTrainingBalance';
import { useAppData } from '@/providers/AppDataProvider';
import { ManageLearningProvider } from '@/providers/ManageLearningProvider';
import { EnrolStudents } from '@/views/manage/EnrolStudents';
import { ManageTraining } from '@/views/manage/ManageTraining';
import { TrainingCourseDetail } from '@/views/manage/TrainingCourseDetail';
import { Theme } from 'klayowebshared';
import { forwardRef } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ManageTrainingCourses } from '../views/manage/ManageTrainingCourses';
import { ManageTrainingStudents } from '../views/manage/ManageTrainingStudents';

interface ManageRoutesProps {
  theme: typeof Theme;
  [key: string]: any;
}

const ManageRoutes = forwardRef<HTMLDivElement, ManageRoutesProps>((props, _ref) => {
  const { user } = useAppData();

  const { amount, isUnlimitedCredit, balances } = useTrainingBalance({
    enabled: !!user?.isTrainingManager,
  });

  return (
    <ManageLearningProvider>
      <Routes>
        <Route
          element={
            <ManageTraining
              {...props}
              amount={amount}
              isUnlimitedCredit={isUnlimitedCredit}
              balances={balances}
            />
          }
        >
          <Route index element={<ManageTrainingCourses />} />
          <Route path='students' element={<ManageTrainingStudents />} />
          <Route path=':id' element={<TrainingCourseDetail theme={props.theme} {...props} />} />
        </Route>
        <Route
          path='enroll-students'
          element={
            user?.isAllowEnrollStudents ? (
              <EnrolStudents
                amount={amount}
                isUnlimitedCredit={isUnlimitedCredit}
                balances={balances}
              />
            ) : (
              <Navigate to='/settings/learning' replace />
            )
          }
        />
      </Routes>
    </ManageLearningProvider>
  );
});

ManageRoutes.displayName = 'ManageRoutes';

export default ManageRoutes;
